import { ConfirmationDialogService } from './../../confirmation-dialog/service/confirmation-dialog.service';
import { ButtonsRowConfig } from './interface/buttons-row.interface';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Page } from "app/dto/page.dto";
import { TableHeaderConfig } from "./interface/table-header.interface";
import { BotonTabla } from './interface/boton-tabla.interface';
import * as moment from "moment";
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { CurrencyFormatPipe } from 'app/@theme/pipes/currency-format.pipe';

@Component({
  selector: "app-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableComponent implements OnInit {
  @Input() headerConfig: TableHeaderConfig[];
  @Input() buttonsRowConfig: ButtonsRowConfig;
  @Input() size: 50;
  @Input() botonesCustom?: BotonTabla[];
  page: Page;
  texto: string = "";
  @Input() pageEvent: EventEmitter<Page>;
  @Output() changePage: EventEmitter<number> = new EventEmitter<number>();
  @Output() changeSize: EventEmitter<number> = new EventEmitter<number>();
  @Output() onDelete: EventEmitter<number> = new EventEmitter<number>();
  @Input() textoLibreEvent: EventEmitter<string>;

  public columns: string[] = [];
  public dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('tabla', { read: ElementRef }) table: ElementRef;
  windowScrolled: boolean;
  prevPageSize = 50;
  botones: BotonTabla[];

  botonEditar = {
    visible: (x: any): boolean => { return true },
    clasesBoton: "mat-raised-button bg-light boton-custom",
    tieneIcono: true,
    icono: "edit",
    clasesIcono: "my-auto",
    clasesEtiqueta: "ml-2",
    title: "Editar",
    click: (args: any) => {
      this.editar(args);
    }
  };

  botonEliminar: BotonTabla = {
    visible: (x: any): boolean => { return true },
    clasesBoton: "mat-raised-button bg-danger boton-custom",
    tieneIcono: true,
    icono: "delete",
    clasesIcono: "my-auto",
    clasesEtiqueta: "ml-2",
    title: "Eliminar",
    click: (args: any) => {
      this.eliminar(args);
    }
  };

  botonVer: BotonTabla = {
    visible: (x: any): boolean => { return true },
    clasesBoton: "mat-raised-button bg-primary boton-custom",
    tieneIcono: true,
    icono: "visibility",
    clasesIcono: "my-auto",
    clasesEtiqueta: "ml-2",
    title: "Visualizar",
    click: (args: any) => {
      this.ver(args);
    }
  };

  esElPrimerRequest = true;
  constructor(private cdr: ChangeDetectorRef, private router: Router, private confirmationDialogService: ConfirmationDialogService, private el: ElementRef) { }

  ngOnInit() {
    this.botones = [];
    if (this.buttonsRowConfig.verActive) {
      this.botones.push(this.botonVer);
    }
    if (this.buttonsRowConfig.editActive) {
      this.botones.push(this.botonEditar);
    }
    if (this.buttonsRowConfig.deleteActive) {
      this.botones.push(this.botonEliminar);
    }
    if (this.botonesCustom && this.botonesCustom.length > 0) {
      this.botones = this.botones.concat(this.botonesCustom);
    }
    this.pageEvent.subscribe(d => {
      if (d) {
        if (this.page) {
          this.esElPrimerRequest = false;
        }
        this.page = d;
        this.dataSource.data = this.page.content;
        this.dataSource.paginator = this.paginator;
        this.cdr.detectChanges();
      }
    });

    if (this.textoLibreEvent)
      this.textoLibreEvent.subscribe(d => {
        if (d) {
          this.texto = d;
          this.cdr.detectChanges();
        }
      });

    if (this.headerConfig.length > 0) {
      this.headerConfig = this.headerConfig.sort(function (a, b) {
        return a.columnOrder - b.columnOrder
      });

      this.headerConfig.forEach(element => {
        this.columns.push(element.title);
      });
      if (this.botones.length > 0) {
        this.columns.push("Acciones");
      }
    }
  }

  getClass(title) {
    const header = this.headerConfig.find(f => f.title == title);
    if (header != undefined) {
      if (header.columnOrder != 0) return 'text-center';
      if (header.center) return 'text-center';
    }
    else
      if (title == "Acciones") return 'text-center'

  }

  getHeaders(): TableHeaderConfig[] {
    return this.headerConfig ? this.headerConfig.sort(function (a, b) {
      return a.columnOrder - b.columnOrder
    }) : [];
  }


  getValue(element: any, title) {
    const headerConfig = this.headerConfig.find(f => f.title == title) as TableHeaderConfig;
    let valor = this.tieneSubElemento(headerConfig.objectKey) ? this.obtenerValor(element, headerConfig.objectKey) : element[headerConfig.objectKey];

    if (headerConfig.custom) {
      return headerConfig.parseCustomHtml(element, headerConfig.html);
    }
    if (typeof valor === "boolean")
      return valor ? "Si" : "No";

    if (headerConfig.capitalize != undefined) valor = this.capitalizePrimeraLetra(valor)

    if (typeof valor == 'string') {
      const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
      const isValid = moment(valor, format, true).isValid();
      if (isValid) {
        var date = moment(valor);
        return date.format("DD/MM/YYYY");
      } else {
        valor = valor.replace("undefined", "");
        if (headerConfig.letters != undefined) {
          if (valor.length > headerConfig.letters) {
            valor = `<span data-title="${valor}">${valor.slice(0, headerConfig.letters)}...</span>`;
          }
        }
      }
    }

    if (typeof valor == "number") {
      let currencyPipe : CurrencyFormatPipe = new CurrencyFormatPipe();
      return currencyPipe.transform(valor);
    }

    if (headerConfig.alias != undefined) {
      let existeValor = headerConfig.alias.find(f => f.value == valor);
      if (existeValor) {
        valor = existeValor.replace;
      } else {
        let valorPorDefecto = headerConfig.alias.find(f => f.default);
        if (valorPorDefecto) {
          valor = valorPorDefecto.replace
        }
      }
    }
    if (headerConfig.color != undefined) {
      const valueId = this.tieneSubElemento(headerConfig.colorId) ? this.obtenerValor(element, headerConfig.colorId) : element[headerConfig.colorId];
      if (valueId != undefined) {
        if (typeof (valueId) === "object") {
          if (valueId.length > 0) {
            const value = headerConfig.color.find(f => f.value == valueId[valueId.length - 1].id);
            if (value != undefined) {
              const div = `<div class="bolita" style="background-color: ${value.color}"></div>`
              valor = div + valor;
            } else {
              const all = headerConfig.color.find(f => f.value == "ALL");
              if (all != undefined) {
                const div = `<div class="bolita" style="background-color: ${all.color}"></div>`
                valor = div + valor;
              }
            }
          } else {
            const all = headerConfig.color.find(f => f.value == "ALL");
            if (all != undefined) {
              const div = `<div class="bolita" style="background-color: ${all.color}"></div>`
              valor = div + valor;
            }
          }
        }
      }
    }
    return valor;
  }

  capitalizePrimeraLetra(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }


  tieneSubElemento(value: string) {
    return value.includes(".");
  }

  obtenerValor(element: any, value: string) {
    let valor = "";
    const levels = value.split(".");
    for (let index = 0; index < levels.length; index++) {
      if (index == 0) {
        valor = element[levels[index]];
      } else {
        if (valor != null && !Array.isArray(valor)) {
          valor = valor[levels[index]];
        } else if (valor != null) {
          if (valor[0] != undefined) {
            valor = valor[0][levels[index]];
          }
        }
        else {
          valor = "";
        }
      }
    }
    return (valor == "undefined") ? "Sin datos" : valor;

    /*
        switch (value.split(".").length) {
          case 2:
            return element[value.split(".")[0]] ? (element[value.split(".")[0]])[value.split(".")[1]] : "";
          case 3:
            return element[value.split(".")[0]] ? ((element[value.split(".")[0]])[value.split(".")[1]])[value.split(".")[2]] : "";
          case 4:
            return element[value.split(".")[0]] ? (((element[value.split(".")[0]])[value.split(".")[1]])[value.split(".")[2]])[value.split(".")[3]] : "";
        }*/
  }


  onPageChange($event) {
    if (!this.esElPrimerRequest || $event !== 1) {
      this.changePage.emit($event);
    }
  }

  onChangeSize($event) {
    this.changeSize.emit($event);
  }

  paginado($event) {
    if (this.prevPageSize != $event.pageSize) {
      this.onChangeSize($event.pageSize);
      this.prevPageSize = $event.pageSize;
    } else {
      const index = ($event.pageIndex == -1) ? 0 : $event.pageIndex;
      this.changePage.emit(index);
    }
  }

  editar(element: any) {
    this.router.navigate([this.buttonsRowConfig.editUrl.replace("{id}", element[this.buttonsRowConfig.fieldIdName])]);
  }

  ver(element: any) {
    this.router.navigate([this.buttonsRowConfig.verUrl.replace("{id}", element[this.buttonsRowConfig.fieldIdName])]);
  }

  eliminar(element: any) {
    this.confirmationDialogService.confirm("Atención", "¿Está seguro que quiere eliminar el registro?")
      .then((confirmed) => {
        if (confirmed) {
          this.onDelete.emit(element[this.buttonsRowConfig.fieldIdName]);
        }
      });
  }

}
